import React, { useEffect, useState } from "react";
import styled from "styled-components";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import moment from "moment";

function ReportModal({ data, setModalOpen, listHandler }) {
  return (
    <>
      <ModalWrapper>
        <ModalBox>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "30px",
            }}
          >
            <TableTitle style={{ marginBottom: "0px" }}>신고 상세</TableTitle>
            <img
              style={{
                cursor: "pointer",
              }}
              src="/assets/admin/icons/ico_popup_close.svg"
              alt=""
              onClick={() => setModalOpen(false)}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              minHeight: "223px",
              overflowY: "auto",
            }}
          >
            <DetailPageForm>
              <DetailFormTitle>신고자 이메일</DetailFormTitle>
              <DetailFormText>{data.reporter?.email}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>피신고자 이메일</DetailFormTitle>
              <DetailFormText>{data.reportedMember?.email}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>작성일</DetailFormTitle>
              <DetailFormText>{moment.utc(data.createAt).format("YYYY/MM/DD")}</DetailFormText>
            </DetailPageForm>
            <DetailPageForm>
              <DetailFormTitle>신고 사유</DetailFormTitle>
              <DetailFormText>{data.reportReason === "ETC" ? data.reportReasonDetail : data.reportReasonTitle}</DetailFormText>
            </DetailPageForm>
            {data.comment ? (
              <DetailPageForm>
                <DetailFormTitle>댓글</DetailFormTitle>
                <DetailFormText>{data.comment}</DetailFormText>
              </DetailPageForm>
            ) : (
              <>
                <DetailPageForm>
                  <DetailFormTitle>게시판 제목</DetailFormTitle>
                  <DetailFormText>{data.boardTitle}</DetailFormText>
                </DetailPageForm>
                <DetailPageForm>
                  <DetailFormTitle>게시판 본문</DetailFormTitle>
                  <DetailFormText>{data.boardContent}</DetailFormText>
                </DetailPageForm>
              </>
            )}
          </div>
        </ModalBox>
      </ModalWrapper>
    </>
  );
}

export default ReportModal;

const ModalWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000060;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 30;
`;

const ModalBox = styled.div.attrs((props) => {})`
  width: 1064px;
  min-height: 397px;
  padding: 50px;
  border: 1px solid #d7dbe0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: relative;
`;
